// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0541e32a","453":"1c87758c","455":"47904b58","977":"6b17b4b9"}[chunkId] + ".chunk.js";
};